import type { VehicleAccessory } from '@ekhodealer/ekho-common';

import { PricedLineItem } from '@common/components/PricedLineItem';

interface AccessoryLineItemProps {
	accessory: VehicleAccessory;
}

/**
 * AccessoryLineItem component that displays an accessory with image, labels, and price.
 * Used for both specs and parts/garments/accessories.
 */
export const AccessoryLineItem = ({ accessory }: AccessoryLineItemProps): React.ReactNode => {
	return (
		<PricedLineItem
			imageUrl={accessory.imgUrl}
			primaryLabel={accessory.name}
			secondaryLabel={accessory.categoryName}
			tertiaryLabel={accessory.description}
			price={accessory.price}
		/>
	);
};
